import React, { useState, useEffect, useContext } from "react";

import cn from "classnames";
import "./style.scss";
import Layout from "./components/Layout";
import bgMain from "./img/bg.jpg";
import bgStep from "./img/bgstep.jpg";
import firstImg from "./img/giphy.gif";
import Header from "./components/Header";
import Popup from "./components/Popup";
import BodyQuiz from "./components/BodyQuiz";
import Title from "./components/Title";
import BoxContent from "./components/BoxContent";
import Content from "./components/Content";
import Button from "./components/Button";
import ProgressBar from "./components/ProgressBar";
import CheckboxContainer from "./components/CheckboxContainer";
import Label from "./components/Label";
import Checkbox from "./components/Checkbox";
import DoneProgress from "./components/DoneProgress";
import Input from "./components/Input";
import Footer from "./components/Footer";
import ErrorField from "./components/ErrorField";
import ErrorFieldCheck from "./components/ErrorFieldCheck/index";
import SelectGlobal from "./components/SelectGlobal";
import Cookies from "./components/Cookies";
import FooterMenu from "./components/FooterMenu";
import { apiRegistration } from "./services/api";
import { ContextProfileUser } from "./lib/profileContext";
import {
  CONST_GENDER_MALE,
  CONST_GENDER_FEMALE,
  COOKIE_QUERY_NAME,
  COOKIE_NAME,
  REGISTRATION_CONFIRMED,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  validateName,
  validateEmail,
  getMonths,
  getYears,
  getDate,
  validateAge,
  getBirthdayInFormat,
  getMonthsByIndex,
  validatePassword,
  deleteCookie,
  gtmRegistration,
  prepareRegistrationData,
  simplyClick,
  hasCookiebotDialog,
  hasConsented,
  sendScreenResolution,
  toggleStorage,
  getTTI,
} from "./helpers";
import {
  errorEventsBirthday,
  errorEventsEmail,
  errorEventsName,
  errorEventsPassword,
  Questing1,
  joinReasons,
  IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
  landingId,
} from "./constants";
import CustomEmailAutoComplete from "./components/CustomEmailAutoComplete";
import Tooltip from "./components/Tooltip";
import { useWizardAnswers, useSessionData } from "ui-components";
import Loader from "./components/Loader";
import radioImg from "./img/Radio.svg";
import LoaderEmail from "./components/LoaderEmail/index";
import LoaderEnd from "./components/LoaderEnd/index";
import { useAppendLandingId } from "./hooks/useAppendLandingId";

const App = () => {
  const [startQuiz, setStartQuiz] = useState(false);
  const [background, setBackground] = useState(bgMain);
  const [step, setStep] = useState(0);
  const [errorName, setErrorName] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(null);
  const [errorCheckbox, setErrorCheckbox] = useState(false);
  const [errorBirthday, setErrorBirthday] = useState(null);
  const [responseError, setResponseError] = useState(null);
  const [cookiesState, setCookiesState] = useState(true);

  const [isOpenMonth, setIsOpenMonth] = useState(false);
  const [isOpenDay, setIsOpenDay] = useState(false);
  const [isOpenYears, setIsOpenYears] = useState(false);
  const [selectionMonth, setSelectionMonth] = useState(null);
  const [selectionDay, setSelectionDay] = useState(null);
  const [selectionYears, setSelectionYears] = useState(null);
  const [cursor, setCursor] = useState(0);
  const [x, setX] = useState(false);

  const { data, setData } = useContext(ContextProfileUser);
  const [gender, setGender] = useState(CONST_GENDER_MALE);

  const [password, setPassword] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({
    3: [],
    4: [],
    5: [],
    6: [],
  });
  const [loadingTextIndex, setLoadingTextIndex] = useState(0);
  const updateAnswer = useWizardAnswers();

  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  const loadingTextsStep6 = [
    <>
      💞 Identifying your ideal partner <br className="br-mobile" />
      based on your <br className="br-dekstop" />
      preferences...
    </>,
    <>
      💬 Matching your relationship <br />
      expectations...
    </>,
    <>
      ❤️ Finding the best communication <br className="br-mobile" /> style{" "}
      <br className="br-dekstop" />
      for you...
    </>,
  ];

  const loadingTextsStep11 = [
    <>
      💞 Aligning compatibility based on <br /> relationship dynamics...
    </>,
    <>
      💬 Understanding your ideal lifestyle <br className="br-mobile" /> and{" "}
      <br className="br-dekstop" />
      values...
    </>,
    <>
      ❤️ Identifying the qualities you <br className="br-mobile" /> admire{" "}
      <br className="br-dekstop" />
      most in a woman...
    </>,
  ];

  const [fade, setFade] = useState(true);
  const [errorBox, setErrorBox] = useState(false);

  const partnersData = 84397;
  const maxPartners = 100000;
  const matchData = 93;
  const maxMatch = 100;

  const allMonths = getMonthsByIndex();
  useAppendLandingId(landingId, [step]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (!hasConsented() && !hasCookiebotDialog()) {
        setCookiesState(false);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".btn--sign");

    if (signInButton) {
      const search = window.location.search
        ? window.location.search + `&landing_id=${landingId}`
        : `?landing_id=${landingId}`;
      signInButton.setAttribute("href", `/login${search}`);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (errorEmail === "This email address has already been used.") {
      const loginLink = document.getElementById("login-link");
      if (loginLink) {
        const handleClick = () => {
          simplyClick("cl_lnd_cd5_againemail_login");
        };
        loginLink.addEventListener("click", handleClick);

        return () => {
          loginLink.removeEventListener("click", handleClick);
        };
      }
    }
  }, [errorEmail]);

  const soldCheckbox = () => {
    setX(!x);
  };

  const cookiesHandler = () => {
    setCookiesState(true);
    toggleStorage(true);
  };

  const handleKeyPress = (e) => {
    if (!isOpenMonth) return;
    if (!isOpenDay) return;
    if (!isOpenYears) return;

    if (e.key === "ArrowUp") {
      // Jump to last option after reaching top
      if (cursor === 0) {
        setCursor(getMonths().length - 1);
        setCursor(getDate().length - 1);
        setCursor(getYears().length - 1);
      } else {
        setCursor(cursor - 1);
      }
    }

    if (e.key === "ArrowDown") {
      // Jump to first option after reaching the bottom
      if (
        cursor === getDate.length - 1 ||
        cursor === getMonths().length ||
        cursor === getYears.length
      ) {
        setCursor(0);
      } else {
        setCursor(cursor + 1);
      }
    }

    if (e.key === "Enter") {
      setSelectionMonth(getMonths[cursor]);
      setSelectionDay(getDate[cursor]);
      setSelectionYears(getYears[cursor]);
    }

    if (e.key === "Escape") {
      setIsOpenMonth(false);
      setIsOpenDay(false);
      setIsOpenYears(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return function cleanUp() {
      window.removeEventListener("keydown", handleKeyPress);
    };
  });

  useEffect(() => {
    if (startQuiz) {
      setBackground(bgStep);
    }
  }, [startQuiz]);

  const handleChangeGender = (event) => {
    setData((prev) => ({ ...prev, gender: event.target.value }));
  };

  const handlerSubmitName = () => {
    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (!status) {
      setErrorName(error.text);
    } else {
      simplyClick("cl_lnd_cd5_name_cont", {
        first_name: data?.first_name,
      });
      setStep(step + 1);
    }
  };

  const handleChangeName = (e) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: e.target.value });
  };

  const handlerSubmitEmail = () => {
    setLoader(true);
    setLoaderTextMain("Checking your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still checking your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderTextMain("");
      setLoaderTextSub("");

      const { status, error } = result;

      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }

      setStep((prevStep) => {
        return prevStep + 1;
      });
    });
  };

  const handleChangeEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  const handleChangeBirthday = () => {
    const { month, day, year } = data;

    if (!month && !day && !year) {
      simplyClick("err_lnd_age_nodate");
      setErrorBirthday("Please enter your full date of birth");
      return;
    }

    const dateKey = [month ? "M" : "", day ? "D" : "", year ? "Y" : ""].join(
      ""
    );

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
      setErrorBirthday("Please enter your full date of birth");
      return;
    }

    const { status, error, errors = {} } = validateAge(month, day, year);

    // No date is entered at all
    if (!status) {
      setErrorBirthday(error);
      return;
    }

    if (errors.invalidDate) {
      setErrorBirthday(error);
      return;
    }

    const formattedBirthday = getBirthdayInFormat(year, month, day);

    setData({
      ...data,
      birthday: formattedBirthday,
    });

    simplyClick("cl_lnd_lt4_13_1_date_birth_cont", {
      birthday: formattedBirthday,
    });

    setStep(step + 1);
  };

  const handleAddMonth = (e) => {
    setErrorBirthday(null);
    setData({ ...data, month: e.target.value });
  };

  const handleAddDay = (e) => {
    setErrorBirthday(null);
    setData({ ...data, day: e.target.value });
  };

  const handleAddYear = (e) => {
    setErrorBirthday(null);
    setData({ ...data, year: e.target.value });
  };

  const isStartQuiz = () => {
    setStartQuiz(true);
  };

  const isViewPassword = () => {
    setPassword(!password);
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const handlerChangePassword = (e) => {
    setErrorPassword(null);
    setShowTooltip(false);
    setData({ ...data, password: e.target.value });
  };

  const postRegistrationRequest = () => {
    const { status, error = { text: "", type: "" } } = validatePassword(
      data.password
    );

    let hasError = false;

    if (!x) {
      simplyClick("err_lnd_checkbox_nocheckbox");

      setErrorCheckbox(true);
      hasError = true;
    } else {
      setErrorCheckbox(false);
    }

    if (!status) {
      setErrorPassword(error.text);
      hasError = true;
    } else {
      setErrorPassword("");
    }

    if (error.type) {
      simplyClick(errorEventsPassword[error.type]);
    }

    if (hasError) return;

    nextStep();
  };

  useEffect(() => {
    if (step === 20) {
      const timeout = setTimeout(() => {
        simplyClick("sh_lnd_cd5_creating");
        apiRegistration(prepareRegistrationData(data), responseCb);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [step]);

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);

        gtmRegistration(data.data);
        simplyClick("cl_lnd_cd5_password_cont");

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed === REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";

        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];

          errorText += i > 0 ? " " + error.message : error.message;
        }

        setResponseError(errorText);
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  const MAX_SELECTION = 4;

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) => {
      const currentStepOptions = prev[step] || [];

      if (step === 3) {
        setErrorBox(false);

        const selectedOptionEntry = Object.entries(joinReasons).find(
          ([id, obj]) => obj.label === option
        );

        if (selectedOptionEntry) {
          const [id, obj] = selectedOptionEntry;

          simplyClick(obj.event);

          updateAnswer({ join_reasons: [id] });
        }

        return {
          ...prev,
          [step]: [option],
        };
      }
      if (step === 4) {
        setErrorBox(false);
        simplyClick("cl_lnd_cd5_sec_ques_choose", { text: option });
        return {
          ...prev,
          [step]: [option],
        };
      }

      if (currentStepOptions.includes(option)) {
        const updatedOptions = currentStepOptions.filter(
          (item) => item !== option
        );

        if (updatedOptions.length > 0) {
          setErrorBox(false);
        } else {
          setErrorBox("To proceed, please respond to this question");
        }

        return {
          ...prev,
          [step]: updatedOptions,
        };
      }

      if (currentStepOptions.length >= MAX_SELECTION) {
        setErrorBox(`You can select up to ${MAX_SELECTION} options.`);
        return prev;
      }

      const updatedOptions = [...currentStepOptions, option];
      setErrorBox(false);

      return {
        ...prev,
        [step]: updatedOptions,
      };
    });
  };

  const isChecked = (option) => {
    return selectedOptions[step]?.includes(option);
  };

  useEffect(() => {
    let activeTexts = [];

    if (step === 6) {
      activeTexts = loadingTextsStep6;
    } else if (step === 11) {
      activeTexts = loadingTextsStep11;
    } else {
      return;
    }

    let textTimer;
    let nextStepTimer;

    setLoadingTextIndex(0);
    setFade(true);

    textTimer = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setLoadingTextIndex((prev) =>
          prev < activeTexts.length - 1 ? prev + 1 : prev
        );
        setFade(true);
      }, 500);
    }, 2000);

    nextStepTimer = setTimeout(() => {
      nextStep();
    }, activeTexts.length * 2000);

    return () => {
      clearInterval(textTimer);
      clearTimeout(nextStepTimer);
    };
  }, [step]);
  const toggleValueInArray = (array, value) => {
    return array.includes(value)
      ? array.filter((v) => v !== value)
      : [...array, value];
  };

  return (
    <div className="App">
      <Layout step={step}>
        <Header step={step} />
        <ProgressBar step={step} opacity={step > 0 ? "1" : "0"} />

        <div className={`main-frame ${step === 0 ? "main-page" : ""}`}>
          {step === 0 && (
            <Popup visible={true}>
              <BodyQuiz>
                <Title
                  text={"Find that special someone you are looking for!"}
                />
                <BoxContent gap={32}>
                  <Content
                    classname={"first"}
                    content={
                      <>
                        It seems that the beauty of our members
                        <br />
                        will not leave you indifferent.
                      </>
                    }
                  >
                    <img src={firstImg} alt="firstImg" />
                  </Content>
                  <Button
                    text={"ok"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      setStep(1);
                      isStartQuiz();
                      simplyClick("cl_lnd_cd5_look_for_ok");
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 1 && (
            <Popup visible={step === 1} padding="padding-block">
              <BodyQuiz>
                <Title text={"Welcome!"} />
                <BoxContent gap={48}>
                  <Content
                    content={
                      <>
                        <p>
                          We are glad that you are here.
                          <br /> Tell us more about yourself!
                        </p>
                      </>
                    }
                  />
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd5_welcome_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 2 && (
            <Popup visible={step === 2} padding="padding-block">
              <BodyQuiz>
                <Title text={"I am a"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <div className={"ckeckbox-wrapper"}>
                      <Label labelTitle={"Man"} forId={"Man"}>
                        <Checkbox
                          checked={data.gender === CONST_GENDER_MALE}
                          id={"Man"}
                          type={"radio"}
                          onChange={(e) => {
                            handleChangeGender(e);
                            simplyClick("cl_lnd_cd5_i_am_choose", {
                              text: "Man",
                            });
                          }}
                          value={CONST_GENDER_MALE}
                          name="gender"
                        />
                      </Label>
                      <Label labelTitle={"Woman"} forId={"Woman"}>
                        <Checkbox
                          id={"Woman"}
                          type={"radio"}
                          value={CONST_GENDER_FEMALE}
                          onChange={(e) => {
                            handleChangeGender(e);
                            simplyClick("cl_lnd_cd5_i_am_choose", {
                              text: "Woman",
                            });
                          }}
                          checked={data.gender === CONST_GENDER_FEMALE}
                          name="gender"
                        />
                      </Label>
                    </div>
                  </CheckboxContainer>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd5_i_am_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 3 && (
            <Popup visible={step === 3}>
              <BodyQuiz>
                <div>
                  <Title text={"Question 1"} startQuiz={startQuiz} />
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content content={"What are you looking for?"} />
                    <div className={"ckeckbox-wrapper"}>
                      {Questing1.map((option) => (
                        <Label key={option} labelTitle={option} forId={option}>
                          <Checkbox
                            id={option}
                            checked={isChecked(option)}
                            onChange={() => {
                              handleCheckboxChange(option);
                            }}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>

                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick(
                            "err_lnd_cd5_first_ques_to_proceed",
                            null
                          );
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_first_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 4 && (
            <Popup visible={step === 4}>
              <BodyQuiz>
                <div>
                  <Title text={"Question 2"} startQuiz={startQuiz} text2={""} />
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content
                      content={
                        "Are you attracted to women from around the world?"
                      }
                    />
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        "Absolutely, they’re captivating!",
                        ["Not really, but I’m open to new", "experiences"],
                      ].map((option) => {
                        const isArray = Array.isArray(option);
                        const optionValue = isArray ? option.join(" ") : option;

                        return (
                          <Label
                            key={optionValue}
                            labelTitle=""
                            forId={optionValue}
                          >
                            <Checkbox
                              id={optionValue}
                              checked={isChecked(optionValue)}
                              onChange={() => {
                                handleCheckboxChange(optionValue);
                                const updated = toggleValueInArray(
                                  selectedOptions[step] || [],
                                  optionValue
                                );
                              }}
                            />
                            {isArray ? (
                              <>
                                {option[0]} <br /> {option[1]}
                              </>
                            ) : (
                              option
                            )}
                          </Label>
                        );
                      })}
                    </div>
                  </CheckboxContainer>

                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick("err_lnd_cd5_sec_ques_to_proceed");
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_sec_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 5 && (
            <Popup visible={step === 5}>
              <BodyQuiz>
                <div>
                  <Title
                    text={"Question 3"}
                    startQuiz={startQuiz}
                    text2={"Choose up to 4 options "}
                  />{" "}
                  <p className="under_title">Choose up to 4 options</p>
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content
                      content={
                        <>
                          <p>
                            What type of conversation are you <br /> interested
                            in?
                          </p>
                        </>
                      }
                    />
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        "Friendly",
                        "Naughty",
                        "Romantic",
                        "Funny",
                        "Open for all",
                      ].map((option) => (
                        <Label key={option} labelTitle={option} forId={option}>
                          <Checkbox
                            id={option}
                            checked={isChecked(option)}
                            onChange={() => {
                              handleCheckboxChange(option);
                              const updated = toggleValueInArray(
                                selectedOptions[step] || [],
                                option
                              );
                              simplyClick("cl_lnd_cd5_third_ques_choose", {
                                text: updated.join("; "),
                              });
                            }}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick(
                            "err_lnd_cd5_third_ques_to_proceed",
                            null
                          );
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_third_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 6 && (
            <Popup visible={step === 6} padding="padding-block">
              <BodyQuiz>
                <Title text={"Analyzing your answers…"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <div className="loader_quiz">
                    <p className={`fade-slide-text ${fade ? "visible" : ""}`}>
                      {loadingTextsStep6[loadingTextIndex]}
                    </p>
                    <Loader />
                    <p>
                      This won’t take long - just a moment while we process your
                      responses.
                    </p>
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 7 && (
            <Popup visible={step === 7} classname={"popup-welldone"}>
              <BodyQuiz>
                <Title text={"Great job!"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <div className={"well-done-wrapper"}>
                    <DoneProgress
                      dataProgress={partnersData}
                      maxValue={maxPartners}
                    >
                      <div>
                        <nobr>
                          Number of <b>potential partners</b>:{" "}
                          <span>84 397</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <DoneProgress dataProgress={matchData} maxValue={maxMatch}>
                      <div>
                        <nobr>
                          The probability of find a <b>match</b>:{" "}
                          <span>{matchData}%</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <p>
                      You’re getting closer to finding the{" "}
                      <span>perfect match. </span>
                    </p>
                    <Content
                      content={
                        "Click “Continue” to keep going and get closer to your ideal partner!"
                      }
                    />
                  </div>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd5_great_job_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 8 && (
            <Popup visible={step === 8}>
              <BodyQuiz>
                <div>
                  <Title
                    text={"Question 4"}
                    startQuiz={startQuiz}
                    text2={""}
                  />{" "}
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content
                      content={"What if a woman takes the first step?"}
                    />
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        [
                          "Yes, I appreciate when a woman",
                          "makes the first move",
                        ],
                        "I don’t mind either way",
                      ].map((option) => {
                        const isArray = Array.isArray(option);
                        const optionValue = isArray ? option.join(" ") : option;

                        return (
                          <Label
                            key={optionValue}
                            labelTitle=""
                            forId={optionValue}
                          >
                            <Checkbox
                              id={optionValue}
                              checked={
                                (selectedOptions[step] || [])[0] === optionValue
                              }
                              onChange={() => {
                                const updated = [optionValue];
                                setSelectedOptions((prev) => ({
                                  ...prev,
                                  [step]: updated,
                                }));
                                simplyClick("cl_lnd_cd5_fourth_ques_choose", {
                                  text: optionValue,
                                });
                              }}
                            />
                            {isArray ? (
                              <>
                                {option[0]} <br /> {option[1]}
                              </>
                            ) : (
                              option
                            )}
                          </Label>
                        );
                      })}
                    </div>
                  </CheckboxContainer>
                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick(
                            "err_lnd_cd5_fourth_ques_to_proceed",
                            null
                          );
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_fourth_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 9 && (
            <Popup visible={step === 9}>
              <BodyQuiz>
                <div>
                  <Title
                    text={"Question 5"}
                    startQuiz={startQuiz}
                    text2={"Choose up to 4 options "}
                  />{" "}
                  <p className="under_title">Choose up to 4 options</p>
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content>
                      <p>
                        Which type of lifestyle describes you the <br /> most?
                      </p>
                    </Content>
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        "Outdoorsy, adventurous",
                        "Cozy, introverted",
                        "Social, vibrant",
                        "Minimalist living",
                        "Creative, artistic",
                      ].map((option) => (
                        <Label key={option} labelTitle={option} forId={option}>
                          <Checkbox
                            id={option}
                            checked={isChecked(option)}
                            onChange={() => {
                              handleCheckboxChange(option);
                              const updated = toggleValueInArray(
                                selectedOptions[step] || [],
                                option
                              );
                              simplyClick("cl_lnd_cd5_fifth_ques_choose", {
                                text: updated.join("; "),
                              });
                            }}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick(
                            "err_lnd_cd5_fifth_ques_to_proceed",
                            null
                          );
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_fifth_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 10 && (
            <Popup visible={step === 10}>
              <BodyQuiz>
                <div>
                  <Title
                    text={"Question 6"}
                    startQuiz={startQuiz}
                    text2={"Choose up to 4 options "}
                  />{" "}
                  <p className="under_title">Choose up to 4 options</p>
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content>
                      <p>What do you like about women the most?</p>
                    </Content>
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        "Modesty",
                        "Seductiveness",
                        "Confidence",
                        "Intelligence",
                        "Spontaneity",
                        "Sense of humor",
                      ].map((option) => (
                        <Label key={option} labelTitle={option} forId={option}>
                          <Checkbox
                            id={option}
                            checked={isChecked(option)}
                            onChange={() => {
                              handleCheckboxChange(option);
                              const updated = toggleValueInArray(
                                selectedOptions[step] || [],
                                option
                              );
                              simplyClick("cl_lnd_cd5_sixth_ques_choose", {
                                text: updated.join("; "),
                              });
                            }}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        if ((selectedOptions[step] || []).length === 0) {
                          setErrorEmail(true);
                          simplyClick(
                            "err_lnd_cd5_sixth_ques_to_proceed",
                            null
                          );
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_sixth_ques_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 11 && (
            <Popup visible={step === 11} padding="padding-block">
              <BodyQuiz>
                <Title text={"Refining your match…"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <div className="loader_quiz">
                    <p className={`fade-slide-text ${fade ? "visible" : ""}`}>
                      {loadingTextsStep11[loadingTextIndex]}
                    </p>
                    <Loader />
                    <p>
                      This won’t take long - just a moment while we process your
                      responses.
                    </p>
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 12 && (
            <Popup visible={step === 12} classname={"popup-welldone"}>
              <BodyQuiz>
                <Title text={"Great job!"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <div className={"well-done-wrapper"}>
                    <DoneProgress
                      dataProgress={partnersData}
                      maxValue={maxPartners}
                    >
                      <div>
                        <nobr>
                          Number of <b>potential partners</b>:{" "}
                          <span>24,567</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <DoneProgress dataProgress={matchData} maxValue={maxMatch}>
                      <div>
                        <nobr>
                          The probability of find a <b>match</b>:{" "}
                          <span>98%</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <p className="text_loading_additional">
                      With your answers, we've narrowed the pool even further
                      and increased the chances of finding your{" "}
                      <span>ideal match.</span>
                    </p>
                    <Content
                      content={
                        "Click “Continue” to keep refining your profile!"
                      }
                    />
                  </div>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd5_great_job_2_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 13 && (
            <Popup visible={step === 13}>
              <BodyQuiz>
                <div>
                  <Title text={"Question 7"} startQuiz={startQuiz} text2={""} />
                </div>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content>
                      <>
                        Would you be open to investing in a <br /> premium
                        experience to meet someone <br /> special?
                      </>
                    </Content>
                    <div className={"ckeckbox-wrapper"}>
                      {[
                        ["I’d be ready to invest in a premium", "experience"],
                        [
                          "I’d consider investing if I find someone",
                          "who really stands out",
                        ],
                        ["I’m just exploring and not ready to", "invest yet"],
                      ].map((optionParts) => {
                        const optionValue = optionParts.join(" ");

                        return (
                          <Label
                            key={optionValue}
                            labelTitle=""
                            forId={optionValue}
                          >
                            <Checkbox
                              id={optionValue}
                              checked={
                                (selectedOptions[step] || [])[0] === optionValue
                              }
                              onChange={() => {
                                setSelectedOptions({
                                  ...selectedOptions,
                                  [step]: [optionValue],
                                });
                                simplyClick("cl_lnd_cd5_sev_ques_choose", {
                                  text: optionValue,
                                });
                              }}
                            />
                            {optionParts.map((part, i) => (
                              <React.Fragment key={i}>
                                {part}
                                {i !== optionParts.length - 1 && <br />}
                              </React.Fragment>
                            ))}
                          </Label>
                        );
                      })}
                    </div>
                  </CheckboxContainer>
                  <div className="btn_error_group">
                    {errorEmail && (
                      <ErrorFieldCheck
                        text={"To proceed, please respond to this question"}
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        const answer = (selectedOptions[step] || [])[0];
                        if (!answer) {
                          setErrorEmail(true);
                          simplyClick("err_lnd_cd5_sev_ques_to_proceed");
                          return;
                        }

                        setErrorEmail(false);
                        simplyClick("cl_lnd_cd5_sev_ques_cont");

                        if (
                          answer ===
                          "I’m just exploring and not ready to invest yet"
                        ) {
                          setStep(14);
                        } else {
                          setStep(15);
                        }
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 14 && (
            <>
              <Popup visible={step === 14} classname="most-men">
                <BodyQuiz>
                  <div className="box_container_info">
                    <p>
                      Most men waste time on free dating{" "}
                      <br className="br-mobile" />
                      websites. Serious users here meet real{" "}
                      <br className="br-mobile" />
                      women and <b>get responses 3x faster!</b>
                    </p>
                    <div className="custom_list">
                      <div className="custom_list-item">
                        <span className="icon">
                          <img src={radioImg} alt="radioImg" />
                        </span>
                        <p>
                          100% real women, eager to connect{" "}
                          <br className="br-mobile" /> and chat.
                        </p>
                      </div>
                      <div className="custom_list-item">
                        <span className="icon">
                          <img src={radioImg} alt="radioImg2" />
                        </span>
                        <p>
                          {" "}
                          No time-wasters, just genuine and{" "}
                          <br className="br-mobile" /> meaningful interactions.
                        </p>
                      </div>
                      <div className="custom_list-item">
                        <span className="icon">
                          <img src={radioImg} alt="radioImg3" />
                        </span>
                        <p>
                          {" "}
                          Find your perfect match faster with{" "}
                          <br className="br-mobile" /> real engagement.
                        </p>
                      </div>
                    </div>

                    <p className="text_btn">
                      Click “Continue” to complete your{" "}
                      <br className="br-mobile" /> registration and start
                      chatting today!
                    </p>

                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd5_most_men_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BodyQuiz>
              </Popup>
            </>
          )}
          {step === 15 && (
            <Popup visible={step === 15} classname="popup--tall thank-you">
              <BodyQuiz>
                <Title
                  text={
                    <>
                      <p>
                        Thank you for <br className="br-mobile" /> answering our{" "}
                        <br className="br-mobile" /> questions!
                      </p>
                    </>
                  }
                  startQuiz={startQuiz}
                  text2={""}
                />
                <BoxContent gap={48}>
                  <div className="close_global">
                    <div className="close_container_text">
                      <p>You’re getting closer to meeting someone special.</p>
                      <div className="close_container_list">
                        <div className="close_container-item">
                          <p>
                            🎁 You’ve earned 20 free coins to{" "}
                            <br className="br-mobile" /> start exploring!
                          </p>
                        </div>
                        <div className="close_container-item">
                          <p>
                            💬 Get real responses from real{" "}
                            <br className="br-mobile" /> women who are ready to
                            chat.
                          </p>
                        </div>
                        <div className="close_container-item">
                          <p>
                            🚀 Experience faster, more{" "}
                            <br className="br-mobile" /> meaningful
                            conversations.
                          </p>
                        </div>
                      </div>
                      <p>
                        Based on your answers, we’ve found the <br />
                        <b>best matches for you.</b>
                      </p>
                    </div>
                    <p className="text_btn">
                      Click “Continue” to complete your <br /> registration and
                      start chatting today!
                    </p>
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd5_thank_you_cont");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 16 && (
            <Popup visible={step === 16} classname={"inner-gap"}>
              <BodyQuiz>
                <div className="group_with_title">
                  <Title
                    text={
                      <>
                        <p>
                          Enter your name or <br /> nickname
                        </p>
                      </>
                    }
                    startQuiz={startQuiz}
                  />
                  <p className="name__text">
                    You don’t have to use your real name – feel free to use a{" "}
                    <br className="br-dekstop" />
                    nickname. You can change it anytime.
                  </p>
                </div>
                <BoxContent gap={32}>
                  <CheckboxContainer className={"mail"}>
                    <Label forId="name">
                      <p>Your name</p>
                      <Input
                        typeInput="text"
                        onChange={handleChangeName}
                        placeholder="Enter your name or nickname"
                        error={errorName}
                        autoComplete="given-name"
                        name="given-name"
                        value={data.first_name || ""}
                        onFocus={() => {
                          setShowTooltip(true);
                          simplyClick("cl_lnd_cd5_name_type_name");
                        }}
                        onBlur={() => setShowTooltip(false)}
                      />

                      {errorName && <ErrorField text={errorName} />}
                      <Tooltip
                        text="Your name must contain at least 2 Latin letters. Special characters and numbers are not allowed."
                        showTooltip={showTooltip}
                      />
                    </Label>
                  </CheckboxContainer>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={handlerSubmitName}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 17 && (
            <Popup
              visible={step === 17}
              classname={"inner-gap"}
              padding="padding-block"
            >
              <BodyQuiz>
                <Title text={"Date of birth"} startQuiz={startQuiz} />
                <BoxContent gap={32}>
                  <div className={"drop-wrapper"}>
                    <SelectGlobal
                      dateArray={getMonths()}
                      data={data?.month}
                      handleChange={handleAddMonth}
                      customClass={"month"}
                      label={"Month"}
                      errorBirthday={errorBirthday}
                    />
                    <SelectGlobal
                      dateArray={getDate()}
                      data={data?.day}
                      handleChange={handleAddDay}
                      customClass={"day"}
                      label={"Day"}
                      errorBirthday={errorBirthday}
                    />
                    <SelectGlobal
                      dateArray={getYears()}
                      data={data?.year}
                      handleChange={handleAddYear}
                      customClass={"year"}
                      label={"Year"}
                      errorBirthday={errorBirthday}
                    />

                    {errorBirthday && <ErrorFieldCheck text={errorBirthday} />}

                    <div className={"birthday_confirm"}>
                      By proceeding you confirm that you are fully legally
                      capable of using website and major or at least 18 years
                      old
                    </div>
                  </div>

                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={handleChangeBirthday}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 18 && (
            <>
              {loader && (
                <LoaderEmail
                  textMain={loaderTextMain}
                  textSub={loaderTextSub}
                />
              )}
              <Popup
                visible={step === 18}
                classname={"inner-gap"}
                padding="padding-block"
              >
                <BodyQuiz>
                  <Title
                    text={
                      <>
                        <p>
                          Enter your real email <br /> address
                        </p>
                      </>
                    }
                    startQuiz={startQuiz}
                  />
                  <BoxContent gap={32}>
                    <CheckboxContainer className={"mail"}>
                      <Label forId={"email"}>
                        <p>Your email</p>
                        <Input
                          typeInput={"text"}
                          onChange={handleChangeEmail}
                          placeholder={"Enter your real email address"}
                          value={data.email ? data.email : ""}
                          autoComplete="email"
                          name="email"
                          error={errorEmail}
                          onFocus={() => {
                            setShowTooltip(true);
                            simplyClick("cl_lnd_cd5_email_type_email");
                          }}
                          onBlur={() => setShowTooltip(false)}
                        />
                        {errorEmail && <ErrorField text={errorEmail} />}
                        <Tooltip
                          text="We'll use this email for account verification and important notifications."
                          showTooltip={showTooltip}
                          className="email"
                        />
                      </Label>
                      {IS_VISIBLE_CUSTOM_AUTOCOMPLETE && (
                        <CustomEmailAutoComplete
                          errorEmail={errorEmail}
                          errorCb={() => setErrorEmail(null)}
                        />
                      )}
                    </CheckboxContainer>
                    {errorEmail ===
                      "This email address has already been used." && (
                      <div className="extra-info">
                        <p>
                          <a
                            href={`/login/?landing_id=${landingId}`}
                            id="login-link"
                          >
                            Log in
                          </a>{" "}
                          or use a different one.
                        </p>
                      </div>
                    )}

                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd5_email_cont");
                        handlerSubmitEmail();
                      }}
                    />
                  </BoxContent>
                </BodyQuiz>
              </Popup>
            </>
          )}

          {step === 19 && (
            <>
              <Popup
                visible={step === 19}
                classname={"popup-password"}
                padding="padding-block"
              >
                <BodyQuiz>
                  <Title text={"Enter your password"} startQuiz={startQuiz} />
                  <BoxContent gap={40}>
                    <CheckboxContainer className={"mail"}>
                      <Label forId={"password"}>
                        <p>Your password</p>
                        <Input
                          typeInput={"password"}
                          onClick={isViewPassword}
                          placeholder={"Enter your password"}
                          onChange={handlerChangePassword}
                          pas={password}
                          value={data.password || ""}
                          error={errorPassword}
                          name="password"
                          autoComplete="password"
                          onFocus={() => {
                            setShowTooltip(true);
                            simplyClick("cl_lnd_cd5_password_type_pass");
                          }}
                          onBlur={() => setShowTooltip(false)}
                        />
                        {errorPassword && <ErrorField text={errorPassword} />}
                        {responseError && <ErrorField text={responseError} />}
                        <Tooltip
                          text="Passwords must be at least 5 characters long. You can recover passwords at any time using the email address you provided."
                          showTooltip={showTooltip}
                        />
                      </Label>
                    </CheckboxContainer>
                    <CheckboxContainer className={"password"}>
                      <Label forId={"password-label"}>
                        <Checkbox
                          id={"password-label"}
                          id2={"custom-checkbox"}
                          errorCheckbox={errorCheckbox}
                          checked={x}
                          onChange={(e) => {
                            simplyClick("cl_lnd_cd5_password_checkbox");
                            soldCheckbox(e);
                            if (e.target.checked) {
                              setErrorCheckbox(false);
                            }
                          }}
                        />
                        <div className={"terms__wrap-block"}>
                          I have read, understand and agree to&nbsp;
                          <span>
                            <a href="/terms-of-use/" target="_blank">
                              Terms of Use,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href="/privacy-policy/" target="_blank">
                              Privacy Policy,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href="/cookie-policy/" target="_blank">
                              Cookie Policy,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href="/billing-policy/" target="_blank">
                              Billing&nbsp;
                            </a>
                          </span>
                          &&nbsp;
                          <span>
                            <a href={"/refund-policy"} target="_blank">
                              Refund Policy,
                            </a>
                          </span>
                          &nbsp;
                          <span>
                            <a href={"/consent-policy"} target="_blank">
                              Consent Policy
                            </a>
                          </span>
                        </div>
                      </Label>
                    </CheckboxContainer>
                    {errorCheckbox && (
                      <ErrorField
                        text={
                          "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy"
                        }
                      />
                    )}
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("   cl_lnd_cd5_password_cont");
                        postRegistrationRequest();
                      }}
                    />
                  </BoxContent>
                </BodyQuiz>
              </Popup>{" "}
            </>
          )}
          {step === 20 && (
            <Popup visible={step === 20} classname={"popup-password"}>
              <BodyQuiz>
                <Title
                  text={
                    <>
                      <p>
                        Creating your perfect <br />
                        match profile...
                      </p>
                    </>
                  }
                  startQuiz={startQuiz}
                />
                <BoxContent gap={40}>
                  <LoaderEnd />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
        </div>
        {!startQuiz && <Footer cookiesNotView={cookiesState} />}
        <div className={step !== 0 ? "custom-footer" : ""}>
          <FooterMenu step={step} />
        </div>
      </Layout>
      <div
        className={cn("site-footer-wrapper", { cookiesNotView: cookiesState })}
      >
        <Cookies
          cookiesClick={cookiesHandler}
          startQuiz={startQuiz}
          cookiesNotView={cookiesState}
        />
      </div>
    </div>
  );
};

export default App;
